import { Select } from "antd";
import { FC } from "react";

const SelectForTestField: FC<any> = (props: any) => {
  return (
    <Select {...props} >
      <Select.Option key="true" > برای تست</Select.Option>
      <Select.Option key="false"   >غیر تستی </Select.Option>
    </Select>
  )
}

export default SelectForTestField
